<template>
    <div class="city_update">
        <tabs>
            <tab name="Genel">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İlçe Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="city">Şehir</label>
                                            <select class="form-control custom-input" v-model="city">
                                                <option value selected hidden disabled>Seçiniz...</option>
                                                <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">İlçe İsmi</label>
                                            <input type="text" class="form-control custom-input" v-model="name">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="slug">SEF Link</label>
                                            <input type="text" class="form-control custom-input" v-model="slug">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Listeleme">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İlçe Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="title">Başlık</label>
                                            <input class="form-control custom-input" v-model="title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="keywords" rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="description">Meta Description</label>
                                            <textarea class="form-control custom-input" v-model="description" rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="spot" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="list_seo">İlçe Description</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="list_seo" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Erkek Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İlçe Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="male_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="male_keywords" rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="male_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="male_spot" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Kız Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İlçe Ekle</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="female_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_keywords">Meta Keywords</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_keywords"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="female_spot" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="row">
            <div class="col-md-12">
                <div class="widget text-center">
                    <div class="form-elements-sec">
                        <button class="btn btn-success" @click="create">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
    components: { VueEditor },
    data() {
        return {
            isReady: false,
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }]
            ],
            cities: [],
            city: "",
            image: "",
            icon: "",
            name: "",
            slug: "",
            title: "",
            keywords: "",
            description: "",
            spot: "",
            content: "",
            list_seo: "",
            male_title: "",
            male_keywords: "",
            male_description: "",
            male_spot: "",
            female_title: "",
            female_keywords: "",
            female_description: "",
            female_spot: ""
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.axios.get("/cities").then(response => {
                this.cities = response.data;
            }).then(() => {
                this.isReady = true;
            });
        },
        create() {
            let data = {
                city: this.city || '' ,
                name: this.name || '' ,
                slug: this.slug || '' ,
                title: this.title || '' ,
                keywords: this.keywords || '' ,
                description: this.description || '' ,
                spot: this.spot || '' ,
                content: this.content || '' ,
                list_seo: this.list_seo || '' ,
                male_title: this.male_title || '' ,
                male_keywords: this.male_keywords || '' ,
                male_description: this.male_description || '' ,
                male_spot: this.male_spot || '' ,
                female_title: this.female_title || '' ,
                female_keywords: this.female_keywords || '' ,
                female_description: this.female_description || '' ,
                female_spot: this.female_spot || '' ,
            };
            const formData = new FormData();
            const config = {headers: {"Content-Type": "multipart/form-data"}};
            formData.append("_method", "POST");
            Object.keys(data).map(e => {
                formData.append(e, data[e]);
            });
            this.$Progress.start();
            // eslint-disable-next-line no-unused-vars
            this.axios.post("districts", formData, config).then(response => {
                // console.log(response);
                this.$Progress.finish();
                if (response.status == 201) {
                    this.$router.push({
                        name: "districts.update",
                        params: {id: response.data.id}
                    });
                }
            }).catch(error => {
                this.$Progress.finish();
                this.loading = false;
                this.$swal.fire({
                    position: 'top-end',
                    type: 'error',
                    title: 'İşlem başarısız!',
                    showConfirmButton: false,
                    timer: 1500
                });
                if (error.response.status == 422) {
                    this.validationErrors = error.response.data.errors;
                } else if (error.response.status == 500) {
                    this.validationErrors = {message: ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!']};
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
